(function () {
  "use strict";

  angular
    .module("alk.maps")
    .factory("mapUtilities", ["ALKMaps", "mapService", "PCMRegion", 
      function mapUtilities(ALKMaps, mapService, PCMRegion) {
        //colors to use on the map with 50% opacity
        var mapColors = ["#123EC4", "#B84A00", "#7318A1", "#1E6CA8", "#B50E59", "#450DBD", "#009DC4", "#E63D00"];
        //colors to use in the UI at full opacity that match the mapColors above at 50% opacity
        var uiColors = ["#889EE1", "#DBA47F", "#B98BD0", "#8EB5D3", "#DA86AC", "#A286DE", "#7FCEE1", "#F29E7F"];

        var mapBaseLayerDefs = {
          "WW": {
            index: 0,
            name: "WWMap",
            region: "EU",
            dataset: "current"
          },
          "NA": {
            index: 1,
            name: "NAMap",
            region: "NA",
            dataset: "Current"
          },
          "EU": {
            index: 2,
            name: "EUMap",
            region: "EU",
            dataset: "PCM_EU"
          },
          "SA": {
            index: 3,
            name: "SAMap",
            region: "SA",
            dataset: "PCM_SA"
          },
          "OC": {
            index: 4,
            name: "OCMap",
            region: "OC",
            dataset: "PCM_OC"
          },
          "ME": {
            index: 5,
            name: "MEMap",
            region: "ME",
            dataset: "PCM_ME"
          },
          "AS": {
            index: 6,
            name: "ASMap",
            region: "AS",
            dataset: "PCM_AS"
          },
          "AF": {
            index: 7,
            name: "AFMap",
            region: "AF",
            dataset: "PCM_AF"
          },
          "GT": {
            index: 8,
            name: "GTMap",
            region: "GT",
            dataset: "PCM_GT"
          }
        };

        var service = {
          getMapColor: getMapColor,
          getUIColor: getUIColor,
          parseCenterParams: parseCenterParams,
          LLtoMerc: LLtoMerc,
          MercToLL: MercToLL,
          zoomToCurrentLocation: zoomToCurrentLocation,
          attachScopeToMapEvents: attachScopeToMapEvents,
          deactivateKeyboardControl: deactivateKeyboardControl,
          activateKeyboardControl: activateKeyboardControl,
          getMapBaseLayerDefs: getMapBaseLayerDefs,
          getRegionFromLonLat: getRegionFromLonLat,
          getCenterLonLatFromRegion: getCenterLonLatFromRegion,
          isPolygonSelfIntersecting: isPolygonSelfIntersecting,
          getDistanceFromCoords: getDistanceFromCoords
        };

        return service;

        ///////////////////////
        function getMapColor(index) {
          if (typeof index !== "undefined" && isNumeric(index)) {
            return mapColors[index % mapColors.length];
          } else {
            return mapColors;
          }
        }

        function getUIColor(index) {
          if (typeof index !== "undefined" && isNumeric(index)) {
            return mapColors[index % mapColors.length];
          } else {
            return mapColors;
          }
        }

        function isNumeric(n) {
          return !isNaN(parseFloat(n)) && isFinite(n);
        }

        function parseCenterParams(params) {
          if (params && params.center) {
            var args = params.center.split(",");
            if (args.length === 3) {
              var zoom = parseInt(args[0], 10),
                lat = parseFloat(args[1]),
                lon = parseFloat(args[2]);
              if (isNaN(zoom) || isNaN(lat) || isNaN(lon)) {
                return false;
              } else {
                return {
                  center: [lon, lat],
                  zoom: zoom
                };
              }
            } else {
              return false;
            }
          }
        }

        function zoomToCurrentLocation() {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
              mapService.setCenter(LLtoMerc(position.coords.longitude, position.coords.latitude), 16);
            }, function (error) {
              console.log(error);
            }, {
              timeout: 10000
            });
          }
        }

        function LLtoMerc(lon, lat) {
          if (typeof (lon) === "object") {
            lat = lon.lat;
            lon = lon.lon;
          }
          return new ALKMaps.LonLat(lon, lat).transform(new ALKMaps.Projection("EPSG:4326"), new ALKMaps.Projection("EPSG:900913"));
        }

        function MercToLL(lon, lat) {
          if (typeof (lon) === "object") {
            lat = lon.lat;
            lon = lon.lon;
          }
          return new ALKMaps.LonLat(lon, lat).transform(new ALKMaps.Projection("EPSG:900913"), new ALKMaps.Projection("EPSG:4326"));
        }

        function attachScopeToMapEvents(scopeToAttach) {
          scopeToAttach.$on("MapInputFocus", function (event, message) { // jshint ignore:line
            deactivateKeyboardControl();
          });

          scopeToAttach.$on("MapInputBlur", function ( /*event, message */ ) {
            activateKeyboardControl();
          });
        }

        function deactivateKeyboardControl() {
          var map = mapService.getMap();
          if (map == null) {
            return;
          }

          for (var i = 0; i < map.controls.length; i++) {
            if (map.controls[i].displayClass === "olControlKeyboardDefaults") {
              map.controls[i].deactivate();
            }
          }
        }

        function activateKeyboardControl() {
          var map = mapService.getMap();
          if (map == null) {
            return;
          }

          for (var i = 0; i < map.controls.length; i++) {
            if (map.controls[i].displayClass === "olControlKeyboardDefaults") {
              map.controls[i].activate();
            }
          }
        }

        function getMapBaseLayerDefs() {
          return mapBaseLayerDefs;
        }

        function getRegionFromLonLat(centerlon, centerlat) {
          var region = "NA";

          if (((centerlat > -36 && centerlat < 11.5) && (centerlon > -27 && centerlon < 64)) || ((centerlat > 11.501 && centerlat < 34) && (centerlon > -27 && centerlon < 34))) {
            region = "AF";
          } else if (((centerlat > -10.8 && centerlat < 10.38) && (centerlon > 70 && centerlon < 146)) || ((centerlat > 8 && centerlat < 27.2) && (centerlon > 71.2 && centerlon < 92.15)) || ((centerlat > 0 && centerlat < 25.6) && (centerlon > 120 && centerlon < 130))) {
            region = "AS";
          } else if (((centerlat > 37.6 && centerlat < 71.5) && (centerlon > -15 && centerlon < 39.5)) || ((centerlat > 55.8 && centerlat < 78) && (centerlon > 0 && centerlon < 179.9)) || ((centerlat > 27.63 && centerlat < 33.20) && (centerlon > -18.25 && centerlon < -13.40))) {
            region = "EU";
          } else if (((centerlat > 25 && centerlat < 75) && (centerlon > -168 && centerlon < -30)) || ((centerlat > 14.6 && centerlat < 25) && (centerlon > -162 && centerlon < -93)) || ((centerlat > 17.5 && centerlat < 19) && (centerlon > -67.5 && centerlon < -63.5))) {
            region = "NA";
          } else if (((centerlat > -44.65 && centerlat < -12.2) && (centerlon > 112.3 && centerlon < 153.4)) || ((centerlat > -47.5 && centerlat < -33) && (centerlon > 165 && centerlon < 179))) {
            region = "OC";
          } else if (((centerlat > 22.75 && centerlat < 27.1) && (centerlon > -79.4 && centerlon < -73)) || ((centerlat > 32.2 && centerlat < 32.5) && (centerlon > -65 && centerlon < -64.5)) || ((centerlat > 17.5 && centerlat < 23) && (centerlon > -74.1 && centerlon < -67.8))) {
            region = "SA";
          } else if ((centerlat > -60 && centerlat < 24) && (centerlon > -86 && centerlon < -32)) {
            region = "SA";
          } else if (((centerlat > 17.5 && centerlat < 20.1) && (centerlon > -74.5 && centerlon < -68.3))) {
            region = "WW";
          } else {
            var lonlat = new ALKMaps.LonLat(centerlon, centerlat);
            var results = ALKMaps.Geocoder.reverseGeocode({
              lonLat: lonlat,
              async: false,
              region: "EU",
              dataset: "current"
            });
            
            if (results[0].Address != null && results[0].Region != null) {
              var regionFromGeocoder = results[0].Region;
              var currentState = results[0].Address.State;
              if (regionFromGeocoder === PCMRegion.AF) {
                region = "AF";
              } else if (regionFromGeocoder === PCMRegion.AS) {
                if (currentState === "PK") {
                  region = "WW";
                } else {
                  region = "AS";
                }
              } else if (regionFromGeocoder === PCMRegion.EU) {
                region = "EU";
              } else if (regionFromGeocoder === PCMRegion.NA) {
                region = "NA";
              } else if (regionFromGeocoder === PCMRegion.OC) {
                region = "OC";
              } else if (regionFromGeocoder === PCMRegion.SA) {
                region = "SA";
              } else if (regionFromGeocoder === PCMRegion.ME) {
                region = "ME";
              }
            }
          }

          return region;
        }

        function getCenterLonLatFromRegion(region) {
          if (!region)
            region = "NA";
          
          var zoom = 5;
          var lat = 38.5;
          var lon = -95;
          
          if (region === "WW") {
            zoom = 3,
            lat = 31.5;
            lon = -44;
          } else if (region === "EU") {
            zoom = 5;
            lat = 47.8;
            lon = 8.4;
          } else if (region === "OC") {
            zoom = 5;
            lat = -27.387;
            lon = 133.164;
          } else if (region === "SA") {
            zoom = 4;
            lat = -19.24;
            lon = -57.43;
          } else if (region === "AF") {
            zoom = 4;
            lat = 8.95;
            lon = 17.46;
          } else if (region === "AS") {
            zoom = 5;
            lat = 19.87;
            lon = 84.21;
          } else if (region === "ME") {
            zoom = 5;
            lat = 30.24;
            lon = 62.85;
          } 
          
          return {
            zoom: zoom,
            lat: lat,
            lon: lon
          };
        }

        function isPolygonSelfIntersecting(polygon) {
          let outer = [];
          if (polygon.CLASS_NAME === "ALKMaps.Geometry.LinearRing") {
            outer = polygon.components;
          } else if (polygon.CLASS_NAME === "ALKMaps.Geometry.Polygon") {
            outer = polygon.components[0].components;
          }
          const segments = outer.slice(1).map((right, i) => {
            const left = outer[i];
            return new ALKMaps.Geometry.LineString([left.clone(), right.clone()]);
          });
          return segments.some(segment => segmentIntersects(segment, segments));
        }

        function segmentIntersects(segment1, segments) {
          return segments.some(segment2 => {
            return !startOrStopEquals(segment1, segment2) && segment1.intersects(segment2);
          });
        }

        function startOrStopEquals(segment1, segment2) {
          if (segment1.components[0].equals(segment2.components[0])) {
            return true;
          }
          if (segment1.components[0].equals(segment2.components[1])) {
            return true;
          }
          if (segment1.components[1].equals(segment2.components[0])) {
            return true;
          }
          if (segment1.components[1].equals(segment2.components[1])) {
            return true;
          }
          return false;
        }

        /*
          calculate the real distance between 2 point.
          If coords are in degree, pass in projection "EPSG:4326"
          If coords are in meters, pass in projection "EPSG:900913"
        */
        function getDistanceFromCoords(lonlat1, lonlat2, projection) {
          var line = new ALKMaps.Geometry.LineString([lonlat1, lonlat2]);
          return line.getGeodesicLength(new ALKMaps.Projection(projection));
        }
      }
    ]);
})();



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-maps/map.utilities.js